<script setup lang="ts">
import AdSlot from '../components/AdSlot.vue';
import { AD_SIZE_PRESETS } from '../config/ads';
</script>

<template>
  <div class="content-page">
    <section class="content-hero">
      <p class="page-badge">Termos de Uso</p>
      <h1>Condições para utilizar o VemChuva Brasil</h1>
      <p class="hero-lead">
        Ao usar o site, você concorda com estas regras para garantir uma experiência segura,
        transparente e alinhada às políticas do Google AdSense.
      </p>
      <div class="page-meta">
        <span>Vigente desde fevereiro de 2025</span>
        <span>Dúvidas: <a href="mailto:contato@vemchuvabrasil.com">contato@vemchuvabrasil.com</a></span>
      </div>
    </section>

    <AdSlot
      :sizes="AD_SIZE_PRESETS.top"
    />

    <section class="content-section">
      <h2>1. Aceitação</h2>
      <p>O uso do site implica concordância com estes Termos e com a <a href="/politica-de-privacidade">Política de Privacidade</a>. Se você não concordar, interrompa o uso.</p>
    </section>

    <section class="content-section">
      <h2>2. Uso permitido</h2>
      <ul class="highlight-list">
        <li>Utilização pessoal ou profissional para consulta de clima e alertas.</li>
        <li>É proibido explorar falhas, realizar scraping massivo ou ações que prejudiquem estabilidade ou segurança.</li>
        <li>Não hospede ou redistribua dados sem citar a fonte e sem autorização quando aplicável.</li>
      </ul>
    </section>

    <section class="content-section">
      <h2>3. Conteúdo e precisão</h2>
      <p>As previsões podem conter imprecisões. Exibimos dados reais com indicação de horário/fonte. Não garantimos adequação para atividades críticas (aviação, operações médicas, emergências).</p>
    </section>

    <section class="content-section">
      <h2>4. Responsabilidade</h2>
      <p>O VemChuva Brasil não se responsabiliza por decisões tomadas exclusivamente com base nas informações exibidas. Em situações de risco, consulte sempre órgãos oficiais.</p>
    </section>

    <AdSlot
      :sizes="AD_SIZE_PRESETS.middle"
    />

    <section class="content-section">
      <h2>5. Propriedade intelectual</h2>
      <p>Marca, layout e código pertencem ao VemChuva Brasil. Você pode compartilhar links e imagens do site com atribuição, sem remover avisos de fonte.</p>
    </section>

    <section class="content-section">
      <h2>6. Privacidade e anúncios</h2>
      <p>Seguimos a Política de Privacidade disponível em <a href="/politica-de-privacidade">/politica-de-privacidade</a>. Anúncios são veiculados via Google AdSense conforme as políticas do programa.</p>
    </section>

    <section class="content-section">
      <h2>7. Suspensão ou mudanças</h2>
      <p>Podemos atualizar funcionalidades, ajustar políticas de conteúdo ou suspender o serviço para manutenção. Comunicaremos mudanças relevantes no site.</p>
    </section>

    <section class="content-section">
      <h2>8. Contato</h2>
      <p>Para dúvidas sobre estes Termos, escreva para <a href="mailto:contato@vemchuvabrasil.com">contato@vemchuvabrasil.com</a>.</p>
    </section>
  </div>
</template>
